export default __webpack_public_path__ + "static/media/screenplayer_01.8b2bfa89.png";